import script from "./SubscriptionInactiveBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubscriptionInactiveBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SubscriptionInactiveBanner.vue?vue&type=style&index=0&id=5816647e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5816647e"]])

export default __exports__